import { env } from "process";
import Container from "../../../../components/container";
import PlaySound from "../../../../components/play-sound";
import { AppFile } from "../../../../models";
import { formatBytes } from "../../../../utils";
import { DeleteFile, Updatefile } from "./buttons";

export default function AppFilesTable({ files }: { files: AppFile[] }) {
        const staticUrl = process.env.REACT_APP_STATIC_URL;

  return (
    <Container className="">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {files?.map((file) => (
          <div key={file.id} className="mb-2 w-full rounded-md bg-white p-4">
            <div className="flex items-center justify-between border-b pb-4">
              <div>
                <div className="mb-2 flex items-center">
                  <p className="text-lg font-medium text-gray-800">
                    {file.fileName}
                  </p>
                </div>
                <p className="text-sm text-gray-500">{file.description}</p>
              </div>
            </div>
            <div className="flex w-full items-center justify-between pt-4">
                 {staticUrl && file ?
                <PlaySound path={staticUrl+ file.path}></PlaySound>:null}
                </div>
            <div className="flex w-full items-center justify-between pt-4">
              <div>
                <p className="text-xs">Content Type</p>
                <p className="text-sm text-gray-500">{file.contentType}</p>
              </div>
              <div>
                <p className="text-xs">Size</p>
                <p className="text-sm text-gray-500">
                  {formatBytes(file.length)}
                </p>
              </div>
              {file.id ? (
                <div className="flex justify-end gap-2">
                  <Updatefile id={file.id}></Updatefile>
                  <DeleteFile id={file.id}></DeleteFile>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      {/* Desktop table */}

      <table className="hidden min-w-full text-gray-900 text-left lg:table ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">
              File Name
            </th>
            <th scope="col" className="px-6 py-3">
              Description
            </th>
            <th scope="col" className="px-6 py-3">
              Content Type
            </th>
            <th scope="col" className="px-6 py-3">
              Size
            </th>
            <th scope="col" className="px-6 py-3">
              Play
            </th>
            <th scope="col" className="px-6 py-3">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {files.map((file) => (
            <tr key={file.id}>
              <td className="whitespace-nowrap px-6 py-3">{file.fileName}</td>
              <td className="px-6 py-4">{file.description}</td>
              <td className="px-6 py-4">{file.contentType}</td>
              <td className="px-6 py-4">{formatBytes(file.length)}</td>
              <td>
                {staticUrl && file ?
                <PlaySound path={staticUrl+ file.path}></PlaySound>:null}
              </td>
              <td className="px-6 py-4">
                {file.id ? (
                  <div className="flex justify-end gap-2">
                    <Updatefile id={file.id}></Updatefile>
                    <DeleteFile id={file.id}></DeleteFile>
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
